var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import { graphql } from "react-apollo";
// finds all addresses submitted by ALL users
export var findXtagQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query FindXtagQuery($xtag: String) {\n    findXtag(xtag: $xtag) {\n      errors {\n        path\n        message\n      }\n      match\n    }\n  }\n"], ["\n  query FindXtagQuery($xtag: String) {\n    findXtag(xtag: $xtag) {\n      errors {\n        path\n        message\n      }\n      match\n    }\n  }\n"])));
// export HOC
export var withFindXtag = graphql(findXtagQuery, {
    props: function (_a) {
        var data = _a.data;
        var response;
        if (data && !data.loading && data.findXtag) {
            response = data.findXtag;
        }
        else {
            throw new Error("Something is wrong (FindXtag Failed)");
        }
        return { response: response, loading: data ? data.loading : false };
    },
});
var templateObject_1;
//# sourceMappingURL=index.js.map